// import { useState, useRef, useEffect } from "react";
// import { useSelector } from "react-redux";
// import AdminSideBar from "./AdminSideBar";
// import AdminContent from "../pages/AdminContent";
// import "../css/adminDashboard.css";

// // Map menu id → page title
// const PAGE_TITLES = {
//   Dashboard:             "Dashboard",
//   Mails:                 "Contact Mails",
//   Verification:          "Verification",
//   Members:               "Members",
//   Report:                "Help Requests",
//   Collection:            "Collection",
//   SadqaBoxAdmin:         "Sadqa Box Requests",
//   MemberAgreementAdmin:  "Member Agreements",
//   VolunteerAdmin:        "Volunteer Applications",
//   Theme:                 "Theme Settings",
// };

// function AdminLayout() {
//   const [activeMenu, setActiveMenu]     = useState("Dashboard");
//   const [sidebarOpen, setSidebarOpen]   = useState(false);
//   const currentTheme = useSelector((s) => s.theme.current);

//   // Close sidebar on outside click (mobile)
//   const overlayRef = useRef(null);

//   function handleSelect(id) {
//     setActiveMenu(id);
//     setSidebarOpen(false);   // close on mobile after pick
//   }

//   // Prevent body scroll when sidebar open on mobile
//   useEffect(() => {
//     if (sidebarOpen) document.body.style.overflow = "hidden";
//     else             document.body.style.overflow = "";
//     return () => { document.body.style.overflow = ""; };
//   }, [sidebarOpen]);

//   return (
//     <div className="ad-shell">

//       {/* ── Mobile overlay ── */}
//       <div
//         ref={overlayRef}
//         className={`ad-overlay ${sidebarOpen ? "ad-overlay-show" : ""}`}
//         onClick={() => setSidebarOpen(false)}
//       />

//       {/* ── Sidebar ── */}
//       <aside
//         className={`ad-sidebar ${sidebarOpen ? "ad-sidebar-open" : ""}`}
//         style={{ background: currentTheme || "#162f06" }}
//       >
//         <AdminSideBar activeMenu={activeMenu} onSelect={handleSelect} />
//       </aside>

//       {/* ── Main ── */}
//       <div className="ad-main">

//         {/* Top bar */}
//         <header className="ad-topbar">
//           <div className="ad-topbar-left">
//             <button
//               className="ad-hamburger"
//               onClick={() => setSidebarOpen((v) => !v)}
//               aria-label="Toggle menu"
//             >
//               {sidebarOpen ? "✕" : "☰"}
//             </button>
//             <h1 className="ad-page-title">
//               {PAGE_TITLES[activeMenu] || activeMenu}
//             </h1>
//           </div>

//           <div className="ad-topbar-right">
//             <div className="ad-topbar-pill">
//               <span className="ad-topbar-dot" />
//               <span>Admin Active</span>
//             </div>
//           </div>
//         </header>

//         {/* Scrollable content */}
//         <div className="ad-content-area">
//           <AdminContent activeMenu={activeMenu} />
//         </div>

//       </div>
//     </div>
//   );
// }

// export default AdminLayout;

// import { useState, useRef, useEffect } from "react";
// import { useSelector } from "react-redux";
// import AdminSideBar from "./AdminSideBar";
// import AdminContent from "../pages/AdminContent";
// // import "../css/adminDashboard.css";

// const PAGE_TITLES = {
//   Dashboard:"Dashboard", Mails:"Contact Mails", Verification:"Verification",
//   Members:"Members", Report:"Help Requests", Collection:"Collection",
//   SadqaBoxAdmin:"Sadqa Box Requests", MemberAgreementAdmin:"Member Agreements",
//   VolunteerAdmin:"Volunteer Applications", Theme:"Theme Settings",
// };

// function AdminLayout() {
//   const [activeMenu, setActiveMenu]   = useState("Dashboard");
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const currentTheme = useSelector((s) => s.theme.current);
//   // console.log(currentTheme)

//   function handleSelect(id) {
//     setActiveMenu(id);
//     setSidebarOpen(false);
//   }

//   useEffect(() => {
//     if (sidebarOpen) document.body.style.overflow = "hidden";
//     else             document.body.style.overflow = "";
//     return () => { document.body.style.overflow = ""; };
//   }, [sidebarOpen]);

//   return (
//     <div className="ad-shell">
//       <div
//         className={`ad-overlay ${sidebarOpen ? "ad-overlay-show" : ""}`}
//         onClick={() => setSidebarOpen(false)}
//       />
//       <aside
//         className={`ad-sidebar ${sidebarOpen ? "ad-sidebar-open" : ""}`}
//         style={{ background: currentTheme || "#162f06" }}
//       >
//         <AdminSideBar activeMenu={activeMenu} onSelect={handleSelect} />
//       </aside>
//       <div className="ad-main">
//         <header className="ad-topbar">
//           <div className="ad-topbar-left">
//             <button
//               className="ad-hamburger"
//               onClick={() => setSidebarOpen((v) => !v)}
//               aria-label="Toggle menu"
//             >
//               {sidebarOpen ? "✕" : "☰"}
//             </button>
//             <h1 className="ad-page-title">{PAGE_TITLES[activeMenu] || activeMenu}</h1>
//           </div>
//           <div className="ad-topbar-right">
//             <div className="ad-topbar-pill">
//               <span className="ad-topbar-dot" />
//               <span>Admin Active</span>
//             </div>
//           </div>
//         </header>
//         <div className="ad-content-area">
//           <AdminContent activeMenu={activeMenu} onNavigate={handleSelect} />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AdminLayout;

import React, { useState, useEffect, Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import AdminSideBar from "./AdminSideBar";

// Lazy load every panel so crashes are isolated
const Dashboard            = lazy(() => import("./Dashboard"));
const Mails                = lazy(() => import("./Mails"));
const Verification         = lazy(() => import("./Verification"));
const Members              = lazy(() => import("./Members"));
const Volunteers           = lazy(() => import("./Volunteers"));
const Report               = lazy(() => import("./Report"));
const Collection           = lazy(() => import("./Collection"));
const SadqaBoxAdmin        = lazy(() => import("./SadqaBoxAdmin"));
const MemberAgreementAdmin = lazy(() => import("./MemberAgreementAdmin"));
const VolunteerAdmin       = lazy(() => import("./VolunteerAdmin"));
const Theme                = lazy(() => import("./Theme"));
const FundsAdmin       = lazy(() => import("./FundsAdmin"));

const PAGE_TITLES = {
  Dashboard:            "Dashboard",
  Mails:                "Contact Mails",
  Verification:         "Verification",
  Members:              "Members",
  Volunteers:           "Volunteers",
  Report:               "Help Requests",
  Collection:           "Collection",
  SadqaBoxAdmin:        "Sadqa Box Requests",
  MemberAgreementAdmin: "Member Agreements",
  VolunteerAdmin:       "Volunteer Applications",
  Theme:                "Theme Settings",
  Funds:                "Funds",
};

class PanelError extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(e) { return { err: e }; }
  componentDidCatch(e, i) { console.error(`Panel [${this.props.name}] crashed:`, e, i?.componentStack); }
  render() {
    if (this.state.err) return (
      <div style={{ padding:"2rem", color:"#c0392b", fontFamily:"monospace", fontSize:"0.85rem" }}>
        <strong>Panel "{this.props.name}" crashed:</strong>
        <pre style={{ whiteSpace:"pre-wrap", wordBreak:"break-all", marginTop:"0.5rem" }}>
          {this.state.err?.toString()}
        </pre>
      </div>
    );
    return this.props.children;
  }
}

function wrap(Component, name, extraProps = {}) {
  return (
    <PanelError name={name}>
      <Suspense fallback={
        <div style={{ padding:"2rem", color:"#888", fontFamily:"sans-serif" }}>
          Loading {name}…
        </div>
      }>
        <Component {...extraProps} />
      </Suspense>
    </PanelError>
  );
}

function AdminContent({ activeMenu, onNavigate }) {
  switch (activeMenu) {
    case "Dashboard":            return wrap(Dashboard,            "Dashboard",            { onNavigate });
    case "Mails":                return wrap(Mails,                "Mails");
    case "Verification":         return wrap(Verification,         "Verification");
    case "Members":              return wrap(Members,              "Members");
    case "Volunteers":           return wrap(Volunteers,           "Volunteers");
    case "Report":               return wrap(Report,               "Report");
    case "Collection":           return wrap(Collection,           "Collection");
    case "SadqaBoxAdmin":        return wrap(SadqaBoxAdmin,        "SadqaBoxAdmin");
    case "MemberAgreementAdmin": return wrap(MemberAgreementAdmin, "MemberAgreementAdmin");
    case "VolunteerAdmin":       return wrap(VolunteerAdmin,       "VolunteerAdmin");
    case "Theme":                return wrap(Theme,                "Theme");
    case "Funds":                return wrap(FundsAdmin,           "Funds");
    default:                     return wrap(Dashboard,            "Dashboard",            { onNavigate });
  }
}

function AdminLayout() {
  const [activeMenu,  setActiveMenu]  = useState("Dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const currentTheme = useSelector((s) => s.theme.current);

  function handleSelect(id) {
    setActiveMenu(id);
    setSidebarOpen(false);
  }

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [sidebarOpen]);

  return (
    <div className="ad-shell">

      {/* Mobile overlay */}
      <div
        className={`ad-overlay ${sidebarOpen ? "ad-overlay-show" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <aside
        className={`ad-sidebar ${sidebarOpen ? "ad-sidebar-open" : ""}`}
        style={{ background: currentTheme || "#162f06" }}
      >
        <AdminSideBar activeMenu={activeMenu} onSelect={handleSelect} />
      </aside>

      {/* Main */}
      <div className="ad-main">
        <header className="ad-topbar">
          <div className="ad-topbar-left">
            <button
              className="ad-hamburger"
              onClick={() => setSidebarOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {sidebarOpen ? "✕" : "☰"}
            </button>
            <h1 className="ad-page-title">
              {PAGE_TITLES[activeMenu] || activeMenu}
            </h1>
          </div>
          <div className="ad-topbar-right">
            <div className="ad-topbar-pill">
              <span className="ad-topbar-dot" />
              <span>Admin Active</span>
            </div>
          </div>
        </header>

        <div className="ad-content-area">
          <AdminContent activeMenu={activeMenu} onNavigate={handleSelect} />
        </div>
      </div>

    </div>
  );
}

export default AdminLayout;